import { ThirdPaneColumnHeader } from '../ThirdPane';
import HistoryTypePicker from './HistoryTypePicker';
import { Box, Flex, Text } from 'rebass';
import { groupHistoryItemsByYearDay } from './helpers';
import React, { useMemo } from 'react';
import { HistoryItem, HistoryItemsByYearDate } from './types';
import './Timeline.styles.css';
import TimelineYear from './TimelineYear';
import Accordion from '@/components/Accordion/Accordion';

type TimelineProps<T extends string> = {
  noRail?: boolean;
  historyItems: HistoryItem[];
  historyItemTypes?: T[];
  title?: string;
  selectedHistoryItemTypes?: T[];
  setSelectedHistoryItemTypes?: (selectedTypes: T[]) => void;
  scrollDivRef: any;
};

const Timeline = <T extends string>({
  noRail = false,
  title = 'History',
  selectedHistoryItemTypes,
  setSelectedHistoryItemTypes,
  historyItemTypes,
  historyItems,
  scrollDivRef,
}: TimelineProps<T>) => {
  // Group by year + date
  const groupedItems: HistoryItemsByYearDate = useMemo(
    () => historyItems.reduce(groupHistoryItemsByYearDay, {}),
    [historyItems]
  );

  // used to set all accordions open
  const years = Object.keys(groupedItems).sort((a, b) => b.localeCompare(a));

  const currentYear = new Date().getFullYear() + '';
  const onlyThisYear = years.length === 1 && years[0] === currentYear;

  return (
    <>
      <ThirdPaneColumnHeader title={title} />
      {historyItemTypes &&
        historyItemTypes.length > 1 &&
        setSelectedHistoryItemTypes && (
          <HistoryTypePicker
            selectedTypes={selectedHistoryItemTypes}
            availableTypes={historyItemTypes}
            onSelectionChange={setSelectedHistoryItemTypes}
            pt={2}
            px={4}
            sx={{
              display: ['none', 'none', 'none', 'flex'],
            }}
          />
        )}
      <Flex
        flexDirection="column"
        flexGrow={1}
        flexShrink={1}
        height="100%"
        overflowY="auto"
        ref={scrollDivRef}
        sx={{ boxSizing: 'border-box' }}
      >
        {onlyThisYear && (
          <Box mt={2} mb={2} ml="20px" mr="10px">
            <TimelineYear
              noRail={noRail}
              itemsByDay={groupedItems[currentYear]}
            />
          </Box>
        )}
        {!onlyThisYear &&
          years.map((year, yearIndex) => {
            // const isFirstYear = yearIndex === 0;
            // const isLastYear =
            //   yearIndex + 1 === Object.keys(groupedItems).length;

            return (
              <Accordion key={year} title={onlyThisYear ? undefined : year}>
                <TimelineYear noRail={noRail} itemsByDay={groupedItems[year]} />
              </Accordion>
            );
          })}
      </Flex>
    </>
  );
};

export default Timeline;
